<template>
    <div id="footer">
        <router-link to='/' class="btn">Home</router-link> - 
        <router-link to='/Video' class="btn">Video</router-link> - 
        <router-link to='/Album' class="btn">Albums</router-link> - 
    <a href="https://www.facebook.com/mortormetal/" target="_blank" class="btn">Facebook</a> - 
    <a href="http://mortor.bandcamp.com" target="_blank" class="btn">Bandcamp</a> - 
    <a href="https://cdnrecords.com/shop/mortor-burn-up-the-dead/" target="_blank" class="btn">CDN records</a>
    </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    a:link, a:visited {
        color: #eeeeee;
        text-align: center; 
        text-decoration: none;
        display: inline-block;
    }

    a:active {
        background-color: red;
        color: red;
    }

    a:hover {
        color: #f44336;
    }

    .btn{
        font-size: 1vw;
    }

    #footer{
        background-color: black;
        padding: 1vh 0;
        position: fixed; 
        bottom:0%;
        width:100%; 
    }

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue